<template>
  <v-app>
    <router-view />
    <notification-queue />
  </v-app>
</template>

<script>
import NotificationQueue from "@/components/NotificationQueue.vue";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
export default {
  components: { NotificationQueue },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
@import "./styles/index.scss";
</style>
